import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M8 0a8 8 0 0 0-8 8 8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8m0 14.5A6.507 6.507 0 0 1 1.5 8c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5m0-4c-.562 0-1 .438-1 1s.41 1 1 1c.534 0 1-.437 1-1s-.466-1-1-1M9.034 4H7.437A2.174 2.174 0 0 0 5.25 6.188c0 .406.344.75.75.75a.76.76 0 0 0 .75-.75c0-.375.284-.688.66-.688h1.596c.403 0 .744.313.744.688 0 .25-.125.44-.344.565l-1.781 1.09a.77.77 0 0 0-.375.657V9c0 .406.344.75.75.75A.76.76 0 0 0 8.75 9v-.062l1.41-.876a2.23 2.23 0 0 0 1.062-1.874C11.25 4.968 10.282 4 9.034 4"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }